// >9 城市视图出现大icon
// >7 <=9 路线视图，无三方点
// <=7 全国视图  有三方背景点和全国资源
export const DEFAULT_COUNTRY_ZOOM_LEVEL = 7 // [ , 7]
export const DEFAULT_CITY_ZOOM_LEVEL = 8.5 // (7, 8.5] // 全国 和 省 分界zoom
export const DEFAULT_DISTRICT_ZOOM_LEVEL = 10.5 // 市区分界zoom
// 展示三方点的缩放级别 >15
export const SHOW_THIRD_ZOOM_LEVEL = 14 // [14, ]    >=14  出现三方点

// ------7------8.5------10.5------14------
// 全国 ] ｜ ( 省  ]｜(  市  ]｜ (   区县---
// 全国 ] ｜ ( 路线 ]｜ ( 大ICON   ) ｜ [ 三方大ICON
